import { TextField } from "@mui/material";
import lodash from "lodash";
import * as React from "react";

import { RobotoTypography } from "@/shared/components/RobotoTypography";
import { useVizDispatch } from "@/shared/state/visualization";
import { updateThreeDEntity } from "@/shared/state/visualization/actions";
import { Entity, Path } from "@/shared/state/visualization/schema/v1/three-d";

import styles from "./EntityConfig.module.css";

interface Props {
  entity: Entity;
  panelId: string;
}

export function PathConfig({ entity, panelId }: Props) {
  const dispatch = useVizDispatch();

  const [lineWidth, setLineWidth] = React.useState(
    `${entity.path?.lineWidth ?? ""}`,
  );
  const [lineWidthError, setLineWidthError] = React.useState("");
  const [color, setColor] = React.useState(entity.path?.color || "#4b77b4");

  React.useEffect(
    function onFieldsChanged() {
      const parsedNumber =
        lineWidth === "" ? undefined : Number.parseFloat(lineWidth);
      setLineWidthError("");
      if (parsedNumber !== undefined && !Number.isFinite(parsedNumber)) {
        setLineWidthError("Line width must be a number");
        return;
      }
      const updated: Path = {
        color,
        lineWidth: Number.isFinite(parsedNumber) ? parsedNumber : undefined,
      };
      if (!lodash.isEqual(updated, entity.path)) {
        dispatch(updateThreeDEntity(panelId, entity.id, { path: updated }));
      }
    },
    [color, lineWidth, entity, dispatch, panelId],
  );

  return (
    <>
      <RobotoTypography variant="body2" className={styles.fieldLabel}>
        Path Trace
      </RobotoTypography>
      <div className={styles.container}>
        <div className={styles.positionRow}>
          <TextField
            label="Line Width"
            type="number"
            size="small"
            margin="dense"
            fullWidth
            value={lineWidth}
            error={!!lineWidthError}
            helperText={lineWidthError}
            onChange={(e) => setLineWidth(e.target.value)}
            className={styles.field}
            InputLabelProps={{ className: styles.input }}
            InputProps={{ className: styles.input }}
            inputProps={{ min: 0, step: 1, className: styles.input }}
          />
          <TextField
            label="Color"
            type="color"
            size="small"
            margin="dense"
            fullWidth
            value={color}
            onChange={(e) => setColor(e.target.value)}
            className={styles.field}
            InputLabelProps={{ className: styles.input }}
            InputProps={{ className: styles.input }}
            inputProps={{ className: styles.input }}
          />
        </div>
      </div>
    </>
  );
}
